import gql from 'graphql-tag';
export default gql`
  mutation DeleteTableById($input: DeleteTableByIdInput!) {
    deleteTableById(input: $input) {
      deletedTableId
    }
  }
`;
